import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { DiscountLevel } from "../models/discount/discount-level";
import { NotificationService } from "../../core/services/notification.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { environment } from "../../../environments/environment";
import { SetRequestServicesDiscount } from "../models/discount/set-request-services-discount";
import { SetRequestDevicesDiscount } from "../models/discount/set-request-devices-discount";

@Injectable()
export class DiscountLevelsService extends DataService<DiscountLevel, DiscountLevel> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'discount-levels';
    }

    getAll(): Observable<DiscountLevel[]> {
        return this.getQuery<DiscountLevel[]>(this.baseUrl());
    }

    setRequestServicesDiscount(model: SetRequestServicesDiscount): Observable<any> {
        return this.postQuery(`${this.baseUrl()}/request-services-discount`, model);
    }

    setRequestDevicesDiscount(model: SetRequestDevicesDiscount): Observable<any> {
        return this.postQuery(`${this.baseUrl()}/request-devices-discount`, model);
    }
}